import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/api/schoolend/login',
    method: 'post',
    data: {
      account:username,
      password
    }
  })
}

export function getInfo(token) {
  return request({
    url: '/api/schoolend/admin/info',
    method: 'get',
    params: { }
  })
}

// export function logout() {
//   return request({
//     url: '/api/schoolend/user/logout',
//     method: 'post'
//   })
// }
